<template>
  <div>
    <div class="d-flex justify-content-end mt-2">
      <div class="form-group">
        <select id=""
                v-model="selecaoView"
                class="custom-select custom-select-sm"
                name="">
          <option v-for="val in listaSelecao"
                  :key="val.id"
                  :value="val.id">
            {{ val.texto }}
          </option>
        </select>
      </div>
    </div>

    <FormConfigLivros v-if="(selecaoView === 1)" />
    <FormSequenLivros v-else-if="(selecaoView === 2)" />
    <protocolo-config v-else />
  </div>
</template>

<script>
  /* components */
  import FormConfigLivros from './FormConfigLivros.vue'
  import FormSequenLivros from './FormSequenLivros.vue'
  import ProtocoloConfig from './Protocolos/ProtocoloConfig'

  export default {
    name: 'AcervosServentia',
    components: {
      FormConfigLivros,
      FormSequenLivros,
      ProtocoloConfig
    },
    props: {
      tabActive: Number
    },
    data () {
      return {
        selecaoView: 1,
        listaSelecao: [{
          id: 1,
          texto: 'Configurações dos livros'
        }, {
          id: 2,
          texto: 'Sequência dos Livros e Registros'
        }, {
          id: 3,
          texto: 'Protocolos'
        }],
      }
    },
    created () {
      if (this.$route.query.acao == 'protocolo') {
        this.selecaoView = 3
        this.$router.push({ name: 'cadastro_serventia' })
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/_exports';
</style>
